import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../../components/Common/BreadCrumb/BreadCrumb";
import JobsHeader from "../../../../components/Common/JobsHeader/JobsHeader";
import FilterComponent from "../../../../components/Common/FilterJobs/FilterJobs";
// import "./LOngoingJobs.scss";
import graphqlRequest from "../../../../requestMethod";
import ShiftJobTable from "../../../../components/Table/Locum/ShiftJobTable/ShiftJobTable";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { pushEvent } from "../../../../utils/clevertap";

const OngoingJobs = () => {
  let [tableData, setTableData] = useState([]);

  let data = localStorage.getItem("auth");
  let token = JSON.parse(data)?.accessToken;
  let [filterTable, setFilterTable] = useState([]);

  let [departmentList, setDepartmentList] = useState([]);
  let [departmentValue, setDepartmentValue] = useState("");

  let [professionalList, setProfessionalList] = useState([]);
  let [professionsValue, setProfessionValue] = useState("");

  let [globalInputSearch, SetGlobalInputSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [filterDate, setFilterDate] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [totalData, setTotalData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  let [filterByProfession, setFilterByProfession] = useState("");
  let [filterByDepartment, setFilterByDepartment] = useState("");
  let [filterByStartDate, setFilterByStartDate] = useState("");
  let [filterByEndDate, setFilterByEndDate] = useState("");
  let [filterByBranch, setFilterByBranch] = useState("");
  let [filterByStatus, setFilterByStatus] = useState("");
  let [hospitalBranchList, setHospitalBranchList] = useState([]);

  let [hospitalBranchData, setHospitalBranchData] = useState([]);
  const [hospitalBranch, setHospitalBranch] = useState("");
  const [hospitalBranchId, setHospitalBranchId] = useState("");
  let [csvData, setCsvData] = useState([]);
  let [downloadTable, setDownloadTable] = useState([]);

  const [selectedJobs, setSelectedJobs] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  // Add these states
  const [selectedShifts, setSelectedShifts] = useState([]);

  function check(start, end, current) {
    if (current >= start && current < end) {
      return true;
    } else {
      return false;
    }
  }
  function filterDepartment(data) {
    let onlyDep = Array.from(new Set(data.map((data) => data?.department)));
    setDepartmentList(onlyDep);
  }
  function filterProfessional(data) {
    let onlyPro = Array.from(new Set(data.map((data) => data?.profession)));
    setProfessionalList(onlyPro);
  }
  function filterShiftJobTable(query) {
    function search(user) {
      return Object.keys(this).every((key) => {
        if (
          (key == "start" || key == "end") &&
          check(this["start"], this["end"], new Date(Number(user["start"])))
        ) {
          return true;
        } else if (key != "end") {
          return user[key] === this[key];
        }
      });
    }
    let filterData = tableData.filter(search, query);

    setFilterTable(filterData);
  }

  function filterHospitalBranch(data) {
    // console.log("data", data)
    let onlyPro = Array.from(new Set(data.map((data) => data.branch)));
    setHospitalBranchList(onlyPro);
  }

  function fetchHospitalDropdownData() {
    const query = `
    query{
      withAuth(token:"${token}"){
        listMiniJobBranches{
          id
          jobLocation {
            hospitalName
            branchName
          }
       }
       }
     }
  `;
    graphqlRequest(query).then((response) => {
      // console.log("response>>>>>", response);
      setHospitalBranchData(response.data.withAuth.listMiniJobBranches);
    });
  }
  // console.log("hospitalBranchData", hospitalBranchData);
  const hospitalBranchOptions = [];
  hospitalBranchData.map((ele) => {
    // console.log("ele", ele);
    let obj = {
      key: ele.id,
      value: ele.jobLocation.branchName,
    };

    hospitalBranchOptions.push(obj);
  });

  // console.log("hospitalBranchOptions", hospitalBranchOptions);

  const handleBranchFilterChange = (e) => {
    const selectedBranch = e.target.value;
    let selectedBranchObjectID;

    hospitalBranchOptions.forEach((branch) => {
      // console.log("branch", branch);
      if (branch.value === selectedBranch) {
        // selectedBranchObjectID = branch.key;
        selectedBranchObjectID = branch.value;
      }
    });

    setHospitalBranch(selectedBranch);
    setHospitalBranchId(selectedBranchObjectID);

    // dispatch(filterRole(selectedRoleObjectID));
  };

  let fetchShiftLogs = () => {
    setLoading(true);
    const query = `
    query {
      
        withAuth(token: "${token}") {
          listMiniJobShiftLogs(limit: ${limit}, offset: ${currentPage}, search: "${keyword}", filterByProfession: "${filterByProfession}", department: "${filterByDepartment}", startDate: "${filterByStartDate}", endDate:"${filterByEndDate}", filterByHospitalBranch: "${hospitalBranchId}", approved: "${filterByStatus}")
           {
            id
            profession
            department
            code
            specialization
            shift
            user
            userId
            date
            in
            out
            log
            cost
            approved
            branch
            startDateTime
            endDateTime
            approvedAt
            disputedReason
            disputedComment
            disputedCreatedAt
            resolvedReason
            resolvedComment
            resolvedApprovedAt
            actualJobHours
            professional{
           id
            status
            avatar{
            url
            }
            professionalRegistration{
              nameAsPerDocument
              number
              registrationDate{
                year
                month
                date
              }
              registrationState
              instituteName
              expiryDate{
                year
                month
                date
              }
            }
            profile{
              education{
                name
                year
                course
              }
              jobHistory{
                hospital
                department
                specialisation

                start
                end
              }
            }
             specialization {
            name
            id
          }
              departments{
              id
              name
            }
            name {
            full
          }
              professionalType {
            name
          }
               numExperience {
            name
          }
              qualification {
            name
          }
            professionalResume{
              resumeStatus
              manualResumeUrl
              AIResumeUrl
            }
            documents{
              docType{
                name
              }
              files{
                url
              }
            }
          }
            job {
            id
            code
            department
            specialization
            start
            end
          jobDescription
          applications
          applicants
          hospitalName
          contactDetail{
                contactPerson
                email
                phone
            }
        }
          }
        
      }
      
  }
    `;

    graphqlRequest(query).then((response) => {
      setTotalData(response?.data?.shiftsCount || 0);
      setTableData(response.data.withAuth.listMiniJobShiftLogs);
      setLoading(false);
      setFilterTable(response.data.withAuth.listMiniJobShiftLogs);
      filterDepartment(response.data.withAuth.listMiniJobShiftLogs);
      filterProfessional(response.data.withAuth.listMiniJobShiftLogs);
      filterHospitalBranch(response.data.withAuth.listMiniJobShiftLogs);
      let data = response.data.withAuth.listMiniJobShiftLogs;
      let arr = [
        [
          "Job ID",
          "Professional Name",
          "Profession",
          "Specialization",
          "Department",
          "Hospital Branch",
          // "Date",
          "Start Date",
          "End Date",
          "In-Time",
          "Out-Time",
          "Total Cost",
          "Actual Job Hours",
          "Status",
        ],
      ];
      if (data) {
        data.map((obj) => {
          // console.log("obj", obj);
          let rowArray = [];
          rowArray.push(obj?.code);
          rowArray.push(obj?.user);

          rowArray.push(obj?.profession);
          rowArray.push(obj?.specialization);
          rowArray.push(obj?.department);

          rowArray.push(obj?.branch);
          // rowArray.push(
          //   new Date(Number(obj?.date))
          //     .toDateString()
          //     .split(" ")
          //     .slice(1)
          //     .join(" ")
          // );
          rowArray.push(
            new Date(Number(obj?.startDateTime))
              .toDateString()
              .split(" ")
              .slice(1)
              .join(" "),
          );
          rowArray.push(
            new Date(Number(obj?.endDateTime))
              .toDateString()
              .split(" ")
              .slice(1)
              .join(" "),
          );
          rowArray.push(
            new Date(Number(obj?.in)).toLocaleTimeString().split(",")[0],
          );
          rowArray.push(
            new Date(Number(obj?.out)).toLocaleTimeString().split(",")[0],
          );
          rowArray.push(obj?.cost?.toLocaleString("en-IN"));
          rowArray.push(obj?.actualJobHours?.toLocaleString("en-IN"));
          rowArray.push(obj?.approved);

          arr.push(rowArray);
        });

        setCsvData(arr);
      }
    });
  };
  let removeOpenJob = (id) => {
    const query = `
      mutation{
        mutationWithAuth(token:"${token}"){
          update{
            revokeMiniJobOffers(job:"${id}")
          }
        }
      }
    `;

    graphqlRequest(query).then((response) => {
      fetchShiftLogs();
    });
  };
  function filterGlobalSearch() {
    let data = tableData?.filter((data) => {
      if (
        data?.code?.toUpperCase().includes(globalInputSearch.toUpperCase()) ||
        data?.specialization
          .toUpperCase()
          .includes(globalInputSearch.toUpperCase())
      ) {
        return data;
      }
    });
    setFilterTable(data);
  }
  useEffect(() => {
    fetchShiftLogs();
  }, [
    currentPage,
    limit,
    keyword,
    filterByProfession,
    filterByDepartment,
    filterByStartDate,
    filterByEndDate,
    filterByBranch,
    hospitalBranch,
    hospitalBranchId,
    filterByStatus,
  ]);

  useEffect(() => {
    fetchHospitalDropdownData();
  }, []);
  useEffect(() => {
    filterGlobalSearch();
  }, [globalInputSearch]);

  useEffect(() => {
    let query = {};
    !!departmentValue && (query["department"] = departmentValue);

    !!professionsValue && (query["profession"] = professionsValue);
    // create this like query and passed in funcation as an object
    !!filterDate[0]?.startDate &&
      (query["start"] = new Date(filterDate[0]?.startDate));
    !!filterDate[0]?.endDate &&
      (query["end"] = new Date(filterDate[0]?.endDate));

    query?.end && query?.end?.setHours(23, 59, 59);

    filterShiftJobTable(query); // call that funcation, which filter the table data
  }, [departmentValue, professionsValue, filterDate]);

  const handleCsvDownload = () => {
    const title = "Shifts Log";
    pushEvent("Web_ShiftLogs_CSV_Download", {
      page: "Reports",
      reportTitle: title,
    });
  };
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "landscape"; // Use landscape for more width

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Shifts_Log";
    pushEvent("Web_ShiftLogs_Pdf_Download", {
      page: title,
    });
    const headers = [
      [
        "Job ID",
        "Professional Name",
        "Profession",
        "Specialization",
        "Department",
        "Hospital Branch",
        "Shift Start Date & Time",
        "Shift End Date & Time",
        "Check In-Date & Time",
        "Check Out-Date & Time",
        "Total Cost",
        "Actual Job Hours",
        "Status",
      ],
    ];

    const statusMap = {
      PENDING_APPROVAL: "Pending",
      APPROVED: "Approved",
      DISPUTED: "Disputed",
      RESOLVED: "Approved",
    };

    const data = downloadTable?.map((elt) => [
      elt?.jobId || "",
      elt?.professionalName || "",
      elt?.profession || "",
      elt?.specialization || "",
      elt?.department || "",
      elt?.branch || "",
      elt?.startDateTime || "",
      elt?.endDateTime || "",
      elt?.inTime || "",
      elt?.outTime || "",
      elt?.totalCost?.toLocaleString("en-IN") || "0",
      elt?.actualJobHours || "",
      statusMap[elt?.status] || elt?.status || "",
    ]);

    doc.text(title, marginLeft, 10);

    doc.autoTable({
      startY: 50,
      head: headers,
      body: data,
      tableWidth: "wrap",
      styles: {
        fontSize: 8,
        cellPadding: 3,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [45, 95, 161], // Navy blue color #2D5FA1 in RGB
        textColor: 255,
        halign: "center",
      },
      columnStyles: {
        0: { cellWidth: 40 }, // Job ID
        1: { cellWidth: 60 }, // Professional Name
        2: { cellWidth: 70 }, // Profession
        3: { cellWidth: 70 }, // Specialization
        4: { cellWidth: 70 }, // Department
        5: { cellWidth: 60 }, // Hospital Branch
        6: { cellWidth: 70 }, // Date
        7: { cellWidth: 70 }, // Date
        8: { cellWidth: 70 }, // In-Time
        9: { cellWidth: 70 }, // Out-Time
        10: { cellWidth: 40 }, // Total Cost
        11: { cellWidth: 40 }, //  actualJobHours
        12: { cellWidth: 50 }, // approved
      },
      theme: "striped",
      margin: { top: 50 },
    });

    doc.save("Shifts Log Report.pdf");
  };

  //  const exportPDF = () => {
  //     const unit = "pt";
  //     const size = "A4"; // Use A1, A2, A3 or A4
  //     const orientation = "portrait"; // portrait or landscape

  //     const marginLeft = 40;
  //     const doc = new jsPDF(orientation, unit, size);

  //     doc.setFontSize(15);

  //     const title = "Open Job Report";
  //     const headers = [
  //       [
  //         "Job ID",
  //         "Professional Name",
  //         "Profession",
  //         "Specialization",
  //         "Department",
  //         "Hospital Branch",
  //         "Date",
  //         "In-Time",
  //         "Out-Time",
  //         "Total Cost",
  //       ],
  //     ];

  //     const data = downloadTable?.map((elt) => [
  //       elt?.jobId,
  //       elt?.professionalName,
  //       elt?.profession,
  //       elt?.specialization,
  //       elt?.department,
  //       elt?.branch,
  //       elt?.date,
  //       elt?.inTime,
  //       elt?.outTime,
  //       elt?.totalCost,
  //     ]);
  //     let content = {
  //       startY: 50,
  //       head: headers,
  //       body: data,
  //     };

  //     doc.text(title, marginLeft, 40);
  //     doc.autoTable(content);
  //     doc.save("report.pdf");
  //   };
  const updateShiftApprovalStatus = async (shift) => {
    console.log("shift", shift);
    try {
      const query = `
        query {
          withAuth(token: "${token}") {
            updateShiftApprovalStatus(
              jobId: "${shift.id}",
              approved: "APPROVED", 
              userId: "${shift.userId}"
            ) {
              success
              message
              jobId
            }
          }
        }
      `;

      const response = await graphqlRequest(query);
      console.log("API Response:", response); // Add this for debugging

      if (response?.data?.withAuth?.updateShiftApprovalStatus?.success) {
        return {
          success: true,
          message: response.data.withAuth.updateShiftApprovalStatus.message,
        };
      } else {
        const errorMsg =
          response?.errors?.[0]?.message ||
          response?.data?.withAuth?.updateShiftApprovalStatus?.message ||
          "Failed to approve shift";
        throw new Error(errorMsg);
      }
    } catch (error) {
      console.error("Error in updateShiftApprovalStatus:", error);
      return {
        success: false,
        message: error.message,
      };
    }
  };
  const handleApprove = async (shift, onSuccess) => {
    try {
      const result = await updateShiftApprovalStatus(shift);
      console.log("result>>", result);
      if (result.success) {
        // fetchShiftLogs(); // Refresh data
        if (onSuccess) onSuccess(shift.id);
        return { success: true, message: result.message };
      }
      throw new Error(result.message || "Failed to approve shift");
    } catch (error) {
      console.error("Error in handleApprove:", error);
      return { success: false, message: error.message };
    }
  };

  // const handleApproveSelected = async () => {
  //   if (selectedJobs.length === 0) return;

  //   try {
  //     const result = await updateShiftApprovalStatus(selectedJobs);

  //     if (result.success) {
  //       // Refresh the data
  //       fetchShiftLogs();
  //       // Clear selection
  //       setSelectedJobs([]);
  //       setSelectAll(false);
  //     } else {
  //       throw new Error(result.message || 'Failed to approve jobs');
  //     }
  //   } catch (error) {
  //     console.error('Error in handleApproveSelected:', error);
  //     // You might want to show an error message to the user here
  //   }
  // };
  const updateShiftDisputeStatus = async (shift) => {
    console.log("shift>>>>", shift);
    try {
      const query = `
        query {
          withAuth(token: "${token}") {
            updateShiftApprovalStatus(
              jobId: "${shift.id}",
              approved: "DISPUTED", 
              userId: "${shift.userId}",
              disputedReason: "${shift?.category}",
              disputedComment: "${shift?.comment}"
            ) {
              success
              message
              jobId
            }
          }
        }
      `;

      const response = await graphqlRequest(query);
      console.log("API Response:", response); // Add this for debugging

      if (response?.data?.withAuth?.updateShiftApprovalStatus?.success) {
        return {
          success: true,
          message: response.data.withAuth.updateShiftApprovalStatus.message,
        };
      } else {
        const errorMsg =
          response?.errors?.[0]?.message ||
          response?.data?.withAuth?.updateShiftApprovalStatus?.message ||
          "Failed to approve shift";
        throw new Error(errorMsg);
      }
    } catch (error) {
      console.error("Error in updateShiftApprovalStatus:", error);
      return {
        success: false,
        message: error.message,
      };
    }
  };
  const handleDispute = async (shift, onSuccess) => {
    try {
      const result = await updateShiftDisputeStatus(shift);
      console.log("result>>", result);
      if (result.success) {
        // fetchShiftLogs(); // Refresh data
        if (onSuccess) onSuccess(shift.id);
        return { success: true, message: result.message };
      }
      throw new Error(result.message || "Failed to approve shift");
    } catch (error) {
      console.error("Error in handleApprove:", error);
      return { success: false, message: error.message };
    }
  };
  const handleSelectShift = (shiftId) => {
    setSelectedShifts((prev) =>
      prev.includes(shiftId)
        ? prev.filter((id) => id !== shiftId)
        : [...prev, shiftId],
    );
  };

  const handleSelectAllShifts = (e) => {
    if (e.target.checked) {
      const allShiftIds = tableData
        .filter((shift) => shift.status === "PENDING_APPROVAL")
        .map((shift) => shift.id);
      setSelectedShifts(allShiftIds);
    } else {
      setSelectedShifts([]);
    }
    setSelectAll(e.target.checked);
  };
  const handleBulkApprove = async () => {
    if (selectedShifts.length === 0) return;

    try {
      const result = await updateShiftBulkApprovalStatus({
        ids: selectedShifts,
      });

      if (result.success) {
        // Refresh data
        fetchShiftLogs();
        // Clear selection
        setSelectedShifts([]);
        setSelectAll(false);
        // Show success message
        // Add your success notification here
      }
    } catch (error) {
      console.error("Error in bulk approve:", error);
      // Add your error notification here
    }
  };
  const handleSelectJob = (jobId) => {
    setSelectedJobs((prev) =>
      prev.includes(jobId)
        ? prev.filter((id) => id !== jobId)
        : [...prev, jobId],
    );
  };

  const handleSelectAllJobs = (e) => {
    if (e.target.checked) {
      const allJobIds = tableData.map((job) => job.id);
      setSelectedJobs(allJobIds);
    } else {
      setSelectedJobs([]);
    }
    setSelectAll(e.target.checked);
  };
  const updateShiftBulkApprovalStatus = async ({
    ids,
    approved,
    userId,
    category,
    comment,
  }) => {
    try {
      const query = `
        query {
   withAuth(token: "${token}") {
     updateManyShiftLogs(shiftLogs: [
       { jobId: "${ids}", userId: "${userId}" },
       { jobId: "${ids}", userId: "${userId}" },
       { jobId: "${ids}", userId: "${userId}" }
     ]) {       
       success
       message
       totalProcessed
       successCount
       failureCount
     }
   }
}
      `;

      const response = await graphqlRequest(query);
      return (
        response?.data?.withAuth?.updateManyShiftLogs || { success: false }
      );
    } catch (error) {
      console.error("Error updating shift status:", error);
      return { success: false, message: error.message };
    }
  };

  // const handleApproveSelected = async () => {
  //   try {
  //     const query = `
  //       mutation {
  //         withAuth(token: "${token}") {
  //           approveShiftLogs(ids: [${selectedJobs.map(id => `"${id}"`).join(',')}]) {
  //             success
  //             message
  //           }
  //         }
  //       }
  //     `;

  //     const response = await graphqlRequest(query);
  //     if (response?.data?.withAuth?.approveShiftLogs?.success) {
  //       // Refresh the data
  //       fetchShiftLogs();
  //       // Clear selection
  //       setSelectedJobs([]);
  //       setSelectAll(false);
  //     }
  //   } catch (error) {
  //     console.error('Error approving jobs:', error);
  //   }
  // };

  return (
    <div className="acceptedjob-container">
      <div className="acceptedjob-wrapper">
        <JobsHeader title={"Shift Logs"} />
        <BreadCrumb action={"Jobs"} title={"Shift Logs"} />
        <FilterComponent
          fetchAllData={fetchShiftLogs}
          title={"Shifts Log"}
          showDownloadIcon={true}
          professional={"TYPE OF ONGOING JOBS"}
          departmentList={departmentList}
          professionalList={professionalList}
          SetGlobalInputSearch={SetGlobalInputSearch}
          setProfessionValue={setProfessionValue}
          setDepartmentValue={setDepartmentValue}
          globalInputSearch={globalInputSearch}
          setFilterTable={setFilterTable}
          tableData={tableData}
          setFilterDate={setFilterDate}
          filterDate={filterDate}
          departmentValue={departmentValue}
          professionsValue={professionsValue}
          keyword={keyword}
          setKeyword={setKeyword}
          filterByProfession={filterByProfession}
          setFilterByProfession={setFilterByProfession}
          filterByDepartment={filterByDepartment}
          setFilterByDepartment={setFilterByDepartment}
          filterByStartDate={filterByStartDate}
          setFilterByStartDate={setFilterByStartDate}
          filterByEndDate={filterByEndDate}
          setFilterByEndDate={setFilterByEndDate}
          filterByBranch={filterByBranch}
          setFilterByBranch={setFilterByBranch}
          hospitalBranchList={hospitalBranchList}
          hospitalBranch={hospitalBranch}
          handleBranchFilterChange={handleBranchFilterChange}
          hospitalBranchOptions={hospitalBranchOptions}
          setHospitalBranch={setHospitalBranch}
          setHospitalBranchId={setHospitalBranchId}
          csvData={csvData}
          exportPDF={exportPDF}
          handleCsvDownload={handleCsvDownload}
          filterByStatus={filterByStatus}
          setFilterByStatus={setFilterByStatus}
          downloadTable={downloadTable}
        />
        <ShiftJobTable
          loading={loading}
          filterTable={filterTable}
          fetchShiftLogs={fetchShiftLogs}
          totalData={totalData}
          data={filterTable || []}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          limit={limit}
          setLimit={setLimit}
          setDownloadTable={setDownloadTable}
          filterByStatus={filterByStatus} // Add this line
          selectedJobs={selectedJobs}
          onSelectJob={handleSelectJob}
          onSelectAllJobs={handleSelectAllJobs}
          selectAll={selectAll}
          // onApproveSelected={handleApproveSelected}
          updateShiftApprovalStatus={updateShiftApprovalStatus}
          handleApprove={handleApprove}
          handleDispute={handleDispute}
          updateShiftDisputeStatus={updateShiftDisputeStatus}
          showCheckboxes={filterByStatus === "PENDING_APPROVAL"}
          selectedShifts={selectedShifts}
          onSelectShift={handleSelectShift}
          onSelectAllShifts={handleSelectAllShifts}
          // selectAll={selectAll}
          onBulkApprove={handleBulkApprove}
          updateShiftBulkApprovalStatus={updateShiftBulkApprovalStatus}
        />
        {/* {showLogsModal && <ActionLogsModal shift={currentShift} onClose={() => setShowLogsModal(false)} />} */}
      </div>
    </div>
  );
};

export default OngoingJobs;
